"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _LicensedProducts = _interopRequireDefault(require("../LicensedProducts"));
var _Vouchers = _interopRequireDefault(require("../Vouchers"));
var _Licenses = _interopRequireDefault(require("../Licenses"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Product = function Product() {
  var tabList = [{
    name: 'licensed%20products',
    title: 'Licensed Products',
    content: /*#__PURE__*/_react["default"].createElement(_LicensedProducts["default"], null)
  }, {
    name: 'vouchers',
    title: 'Vouchers',
    content: /*#__PURE__*/_react["default"].createElement(_Vouchers["default"], null)
  }, {
    name: 'licenses',
    title: 'Licenses',
    content: /*#__PURE__*/_react["default"].createElement(_Licenses["default"], null)
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
    tabList: tabList,
    saveInHash: true
  });
};
var _default = exports["default"] = Product;